<template>
  <div
    fluid
    text-center
  >
    <v-alert
      v-model="alerta.mostrar"
      dismissible
      :type="alerta.tipo"
    >
      {{ alerta.mensaje }}
    </v-alert>
    <v-spinner v-if="cargando"></v-spinner>
    <template v-else>
      <v-tabs
        color="grey lighten-2"
        show-arrows
        class="elevation-0"
        @change="cambiarSolapa"
      >
        <v-tabs-slider color="secondary"></v-tabs-slider>
        <v-tab
          :key="'emitidos'"
          :href="'#tab-emitidos'"
          class="grey  lighten-2"
          style="font-weight: 700; color: #604492!important"
        >
          Comprobantes Emitidos
        </v-tab>
        <v-tab
          :key="'recibidos'"
          :href="'#tab-recibidos'"
          class="grey  lighten-2"
          style="font-weight: 700; color: #604492!important"
        >
          Comprobantes Recibidos
        </v-tab>

        <v-tabs-items>
          <v-tab-item
            :key="'emitidos'"
            :value="'tab-emitidos'"
          >
            <el-listado
              v-if="listadoEmitidos.mostrar"
              v-bind="listadoEmitidos"
              v-bind:permiso="permiso"
              v-bind:modelo-api="modeloApi"
              v-bind:combos="combos"
              v-on:verItem="ver"
              v-on:crearItem="crear"
              v-on:alFiltrar="alFiltrarEmitidos"
              v-on:accion="accionListado"
              v-on:mostrarError="mostrarError"
            ></el-listado>
          </v-tab-item>
          <v-tab-item
            :key="'recibidos'"
            :value="'tab-recibidos'"
          >
            <el-listado
              v-if="listado.mostrar"
              v-bind="listado"
              v-bind:permiso="permiso"
              v-bind:modelo-api="modeloApi"
              v-bind:combos="combos"
              v-on:verItem="ver"
              v-on:crearItem="crear"
              v-on:mostrarError="mostrarError"
            ></el-listado>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>

      <!--v-dialog
        v-model="formulario.mostrar"
        max-width="800px"
        persistent
        scrollable
      >
        <el-formulario
          v-if="formulario.mostrar"
          v-bind="formulario"
          v-bind:permiso="permiso"
          v-bind:modelo-api="modeloApi"
          v-on:alGuardar="alGuardar"
          v-on:alCerrar="alCerrar"
        ></el-formulario>
      </v-dialog-->

      <!--v-dialog
        v-model="cambioPln.mostrar"
        max-width="800px"
        persistent
        scrollable
      >
        <cambio-pln
          v-if="cambioPln.mostrar"
          v-bind="cambioPln"
          v-bind:permiso="permiso"
          v-bind:modelo-api="modeloApi"
          v-on:alGuardar="alGuardarCambioPln"
          v-on:alCerrar="alCerrarCambioPln"
        ></cambio-pln>
      </v-dialog>
      <v-dialog
        v-model="detallePami.mostrar"
        max-width="800px"
        persistent
        scrollable
      >
        <detalle-dev-pami
          v-if="detallePami.mostrar"
          v-bind="detallePami"
          v-bind:permiso="permiso"
          v-bind:modelo-api="modeloApi"
          v-on:alGuardar="alGuardarDetallePami"
          v-on:alCerrar="alCerrarDetallePami"
        ></detalle-dev-pami>
        </v-dialog-->

      <v-dialog
        v-model="modalAccion.mostrar"
        :max-width="modalAccion.ancho || '100%'"
        persistent
        scrollable
      >
        <component
          v-if="modalAccion.mostrar"
          v-bind:is="modalAccion.componente"
          v-bind="modalAccion"
          v-bind:permiso="permiso"
          v-bind:modelo-api="modeloApi"
          v-on:alGuardar="modalAccion.alGuardar"
          v-on:alCerrar="alCerrar"
        ></component>
      </v-dialog>

    </template>
  </div>
</template>

<script>
import EventBus from '@/helpers/eventBus'
import mixinAbm from '@/mixins/abm'
import ElListado from '../components/FacturacionCentro/FacturacionCentroListado'
import ElFormulario from '../components/FacturacionCentro/FacturacionCentroFormulario'
import CambioPln from '../components/FacturacionCentro/FacturacionCentroCambioPLNComprobante'
import ElDetalle from '../components/FacturacionDetalleComprobante'
import DetalleDevPami from '../components/FacturacionCentro/FacturacionCentroDetalleDevolucionPami'
import FacturacionOrdenesPago from '../components/FacturacionOrdenesPago'
import FacturacionRecibos from '../components/FacturacionRecibos'

import Modelo from '@/api/comprobante'
import _ from 'lodash'
import { fechaLocal, fechaFutura } from '@/helpers/filtros'
import moment from 'moment'
import Combo from '@/api/combo'
export default {
  mixins: [mixinAbm],
  components: {
    ElListado
  },
  props: {
    componente: {
      type: String,
      default: 'listado'
    },
    soloLectura: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      montarMixin: false,
      combos: {},
      cargando: true,
      permiso: 'tesoreria_comprobantes-centro',
      modeloApi: Modelo,
      secciones: ['recibidos', 'emitidos'],
      listado: {
        mostrar: false,
        referencia: 'comprobantesRecibidosListado',
        tipo: 'recibidos'
      },
      listadoEmitidos: {
        mostrar: false,
        referencia: 'comprobantesEmitidosListado',
        tipo: 'emitidos'
      },
      modalAccion: this.masterModalAccion()
    }
  },
  mounted () {
    this.cargarFiltros()
  },
  methods: {
    crear () {
      let vm = this
      let mesActual = parseInt(moment().format('M'))
      let anioActual = parseInt(moment().format('Y'))

      vm.modalAccion = _.assign(vm.masterModalAccion(), {
        componente: ElFormulario,
        operacion: 'alta',
        titulo: 'Alta',
        ancho: '800px',
        item: {
          id: 0,
          institucion_id: null,
          origen: 'centro',
          tipo_receptor_id: null,
          tipo_comprobante_id: null,
          tipo_comprobante: {
            id: null,
            codigo: null
          },
          tipo_comprobante_categoria_id: null,
          punto_venta_id: null,
          facturado_a_obra_social_id: null,
          facturado_a_institucion_id: null,
          facturado_a_obra_social: {
            id: null,
            codigo: null
          },
          facturado_a_institucion: {
            id: null,
            codigo: null
          },
          facturado_por_id: null,
          estado_facturacion_id: null,
          estado_facturacion: {
            codigo: 'abierto'
          },
          estado_pago_id: null,

          numero_comprobante: null,
          fecha: fechaLocal('YYYY-MM-DD'),
          fecha_vencimiento: fechaFutura({ cantidad: 30, formatoSalida: 'YYYY-MM-DD' }),
          fecha_prefactura: null,
          importe_prefacturado: 0,
          importe_facturado: 0,
          cantidad_sesiones_facturadas: null,
          cantidad_pacientes_facturados: null,
          periodo_mes: mesActual === 1 ? 12 : mesActual - 1,
          periodo_ano: mesActual === 1 ? anioActual - 1 : anioActual,
          es_directo: false
        },
        mostrar: true
      })
    },
    ver (item) {
      let vm = this
      vm.modalAccion = _.assign(vm.masterModalAccion(), {
        componente: ElFormulario,
        operacion: 'lectura',
        titulo: 'Ver',
        ancho: '800px',
        item: item,
        mostrar: true
      })
    },

    verDetalle (item) {
      this.modalAccion = _.assign(this.masterModalAccion(), {
        titulo: 'Detalle',
        ancho: '100%',
        componente: ElDetalle,
        comprobanteId: item.id,
        por: 'centro',
        codigoTipoComprobante: item.tipo_comprobante.codigo,
        mostrar: true
      })
    },
    verCambioPln (item) {
      let vm = this
      vm.modalAccion = _.assign(vm.masterModalAccion(), {
        componente: CambioPln,
        operacion: 'lectura',
        titulo: 'Cambio Pto. Vta. / Letra / Nro. Comprobante',
        ancho: '800px',
        item: item,
        mostrar: true
      })
    },
    verDetallePami (item) {
      let vm = this
      vm.modalAccion = _.assign(vm.masterModalAccion(), {
        componente: DetalleDevPami,
        operacion: 'lectura',
        titulo: 'Cambio Pto. Vta. / Letra / Nro. Comprobante',
        ancho: '100%',
        comprobanteId: item.id,
        mostrar: true
      })
    },
    verRecibos (item) {
      let vm = this

      vm.modalAccion = _.assign(vm.masterModalAccion(), {
        operacion: 'lectura',
        titulo: 'Recibos',
        ancho: '100%',
        componente: FacturacionRecibos,
        item: item,
        por: 'centro',
        mostrar: true
      })
    },
    verOrdenesPago (item) {
      let vm = this

      vm.modalAccion = _.assign(vm.masterModalAccion(), {
        operacion: 'lectura',
        titulo: 'Ordenes de Pago',
        ancho: '100%',
        componente: FacturacionOrdenesPago,
        item: item,
        mostrar: true
      })
    },
    alGuardar (item) {
      this.filtrarListado()
      this.alCerrar()
    },
    alCerrar () {
      this.modalAccion.mostrar = false
    },
    filtrarListado (origen) {
      this.ocultarAlerta()
      let listado = origen === 'recibidos' ? this.listado : this.listadoEmitidos
      EventBus.$emit(listado.referencia + ':filtrar')
    },
    cambiarSolapa (solapa) {
      let vm = this
      if (solapa === 'tab-recibidos') {
        vm.listado.mostrar = true
        vm.listadoEmitidos.mostrar = false
      } else {
        vm.listadoEmitidos.mostrar = true
        vm.listado.mostrar = false
      }
    },
    alFiltrarEmitidos () {

    },
    cargarFiltros () {
      let vm = this

      let dataCombos = {
        instituciones: {
          itemVacio: 'Seleccione',
          soloHijos: true,
          asignados: true
        },
        grupoEntidades: {
          categoriasTipoComprobantes: {
            codigo: 'tipo_comprobante_categoria',
            itemVacio: true
          }
        },
        comprobanteTipos: {
          itemVacio: true,
          centros: true
        },
        comprobanteReceptores: {
          laAsociacion: true
        },
        comprobanteEstados: {
          itemVacio: true,
          tipo: 'F'
        },
        periodosAnios: {
          itemVacio: 'Seleccione'
        },
        periodosMeses: {
          itemVacio: 'Seleccione'
        },
        obrasSociales: {
          relaciones: ['planes.facturables'],
          itemVacio: 'Seleccione'
        }
      }
      Combo.listado(dataCombos).then(
        data => {
          vm.combos = _.assign(vm.combos, data)
          vm.cargando = false
        },
        error => {
          vm.mostrarError(error)
          vm.cargando = false
        }
      )
    },
    accionListado (accion, item) {
      let vm = this
      switch (accion) {
        case 'verDetalle':
          vm.verDetalle(item)
          break
        case 'verCambioPln':
          vm.verCambioPln(item)
          break
        case 'verDetallePami':
          vm.verDetallePami(item)
          break
        case 'recibos':
          vm.verRecibos(item)
          break
        case 'ordenesPago':
          vm.verOrdenesPago(item)
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
